<template>
	<div class="top" style="padding-bottom: 20px;">
		<div class="middle-row end">
			<h2 style="padding: 10px 5px;margin-right:360px !important;">设备管理</h2>
			<div class="input-group middle-row" style="margin-right: 20px;">
				<input type="text" class="form-control" placeholder="请输入商户名称或者设备编号" v-model="searchKey" size="30">
				<button class="btn btn-danger" @click="searchEqu" data-toggle="modal" data-target="#merchant"><i
						class="fa fa-search"></i>&nbsp;搜索设备</button>
			</div>

		</div>
		<div class="list middle-row around" style="height: 80px;width: 100%;">
			<div v-for="(item, n) in selected" style="width: 13%;height: 80%;border-radius: 10px;"
				:style="{ backgroundColor: colors[n] }" @click="changeType(n)" :key="n"
				class="middle-row center equtype">
				<h4 :class="index1 == n ? 'edit-active' : ''">{{ item.name }}</h4>
			</div>
		</div>
		<div style="width: auto;height: 660px;margin: 10px;" class="middle-row between">
			<div style="width:32%; height: 100%;background-color: #f7f7f7;padding: 5px;" class="middle-column start">
				<h3 style="color: gray;padding: 5px 0px;">设备列表</h3>
				<div style="width: 95%;height: 95%;display: flex;flex-wrap: wrap;align-content: flex-start;overflow-y:scroll;">
					<div v-for="(merchant, index) in merchants" :id="'mer' + index"
						:class="sub == index ? 'sub-active' : ''" @click="changeSub(index)" class="subitem"
						style="width: 48%;height: 100px;margin: 7px 1%;background-color:#EFEFEF;padding: 10px 0px;border-radius: 5px;"
						:key="index">
						{{ merchant.merchantName }}
					</div>
				</div>
			</div>
			<div style="width: 40%; height: 100%;background-color: white;padding:3px;">
				<baidu-map v-if='showMap' style="height:654px;" class="bm-view" :zoom='zoom' @zoomend="zoomEnd"
					:center="{ lng: merchant.longitude, lat: merchant.latitude }" ak="zqBjGlhZHNC8xz8h0gEmaYPROCXpIK0O"
					:scroll-wheel-zoom='true' @moveend="getCenter">
					<bm-marker :position="{ lng: merchant.longitude, lat: merchant.latitude }" :dragging="false"
						animation="BMAP_ANIMATION_BOUNCE">
					</bm-marker>
				</baidu-map>
			</div>
			<div style="width: 25%; height: 100%;background-color: white;" class="middle-column around edit">
				<div class="input-group">
					<span class="input-group-addon">企业名称</span>
					<input type="text" v-model="merchant.merchantName" class="form-control" placeholder="所属企业">
				</div>
				<div class="input-group">
					<span class="input-group-addon">设备类型</span>
					<select name="" id="select" v-model="merchant.equType" class="form-control">
						<option v-for="(target, i) in selected" :value="target.name" :key='i'>{{ target.name }}</option>
					</select>
				</div>
				<div class="input-group">
					<span class="input-group-addon">设备编号</span>
					<input type="text" v-model="merchant.equNum" class="form-control" placeholder="设备编号">
				</div>
				<div class="input-group">
					<span class="input-group-addon">所属街道</span>
					<select name="" id="select" v-model="merchant.street" class="form-control">
						<option value="东山街道">东山街道</option>
						<option value="南黎街道">南黎街道</option>
						<option value="曲阳街道">曲阳街道</option>
						<option value="渠沟镇">渠沟镇</option>
						<option value="任圩街道">任圩街道</option>
						<option value="三堤口">三堤口</option>
						<option value="相南街道">相南街道</option>
						<option value="相山东街道">相山东街道</option>
						<option value="相山西街道">相山西街道</option>
						<option value="凤凰山经济开发区">凤凰山经济开发区</option>
					</select>
				</div>
				<div class="input-group">
					<span class="input-group-addon">业主名称</span>
					<input type="text" v-model="merchant.owner" class="form-control" placeholder="业主名称">
				</div>
				<div class="input-group">
					<span class="input-group-addon">联系方式</span>
					<input type="text" v-model="merchant.phone" class="form-control" placeholder="联系方式">
				</div>
				<div class="input-group">
					<span class="input-group-addon">经度</span>
					<input type="text" v-model="merchant.latitude" class="form-control" placeholder="经度" disabled>
				</div>
				<div class="input-group">
					<span class="input-group-addon">纬度</span>
					<input type="text" v-model="merchant.longitude" class="form-control" placeholder="纬度" disabled>
				</div>
				<div class="input-group middle-row between" style="width: 60%;">
					<button type="button" class="btn btn-success" @click="updateEqu">提交修改</button>
					<button type="button" class="btn btn-warning" @click="delEqu">删除设备</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	BaiduMap,
	BmMarker,
	BmCircle
} from 'vue-baidu-map'
export default {
	data() {
		return {
			selected: [{
				name: '餐饮油烟排放',
				files: ['油烟浓度', '颗粒物浓度', '非甲烷总烃'],
				type: 'lampblack'
			}, {
				name: 'VOCS排放',
				files: ['VOCS排放'],
				type: 'outdoor'
			}, {
				name: '工地扬尘',
				files: ['pm2.5', 'pm10', '噪声', '温度', '湿度', '风力', '风向', '风速'],
				type: 'dust'
			}, {
				name: '工业企业废气',
				files: ['苯', '苯系物', '非甲烷总烃', '温度', '颗粒物'],
				type: 'carrepair'
			}],
			showMap: false,
			index1: 0,
			sub: 0,
			zoom: 14,
			merchants: [],
			merchant: {
				merchantId: '',
				merchantName: '',
				equType: '',
				equNum: '',
				longitude: '33.96601',
				latitude: '116.80661',
				state: 'offline',
				street: ''
			},
			colors: ['#64b0f2', '#f1b53d', 'lightseagreen', '#ff5d48'],
			searchKey: '',
			namelist: []
		}
	},
	methods: {
		searchEqu: function () {
			var len = this.namelist.length;
			var index = -1;
			var reg = new RegExp(this.searchKey);
			var result = []
			for (var i = 0; i < len; i++) {
				//如果字符串中不包含目标字符会返回-1
				if (this.namelist[i].match(reg)) {
					index = i;
					result.push(i)
				}
			};
			if (result.length == 0) {
				alert("未搜索到指定设备")
			} else if (result.length == 1) {
				this.merchant = this.merchants[index];
				this.sub = index;
				document.getElementById('mer' + index).scrollIntoView();
			} else if (result.length > 2) {
				alert("搜索到多台设备，请完善搜索关键字。")
			}
		},
		changeType: function (n) {
			if (n > 3) {
				return;
			}
			this.index = n;

			this.$http.get(this.GLOBAL.base + 'getMerchants', {
				params: {
					target: this.selected[n].name
				}
			}).then(function (e) {
				this.merchants = e.body;
				if (this.merchants.length > 0) {
					this.merchant = this.merchants[0];
					this.index1 = n;
					this.sub = 0;
				}
			})
		},
		changeSub: function (n) {
			this.sub = n;
			this.merchant = this.merchants[n];
		},
		updateEqu: function () {
			if (confirm('确定修改设备信息？')) {
				this.$http.get(this.GLOBAL.base + 'updateEqu', {
					params: this.merchant
				}).then(function (e) {
					this.merchant = e.body;
				})
				alert('修改成功')
			}
		},
		getCenter: function (e) {
			console.log(e.target.se.lat,e.target.se.lng)
			this.merchant.latitude = e.target.se.lat;
			this.merchant.longitude = e.target.se.lng;
		},
		zoomEnd: function (type, target) {
			this.zoom = type.target.Na;
		},
		delEqu: function () {
			this.$http.post(this.GLOBAL.base + 'delMerchant', this.merchant, {
				emulateJSON: true
			}).then(function (msg) {
				alert(msg.bodyText);
				this.$http.get(this.GLOBAL.base + 'getMerchants', {
					params: {
						target: this.selected[0].name
					}
				}).then(function (e) {
					this.merchants = e.body;
					this.merchant = this.merchants[0];
					this.sub = 0
				})
			}, function (msg) { })
		}
	},
	components: {
		BaiduMap,
		BmMarker,
		BmCircle
	},
	mounted() {
		this.$http.get(this.GLOBAL.base + 'getMerchants', {
			params: {
				target: this.selected[0].name
			}
		}).then(function (e) {
			this.merchants = e.body;
			this.merchant = this.merchants[0];
			this.showMap = true;
			for (let mer of this.merchants) {
				this.namelist.push(mer.merchantName)
			}
		})
	}
}
</script>

<style>
.equtype h4 {
	color: #efefef;
}

.equtype:hover {
	cursor: pointer;
}

.edit-active {
	color: white !important;
	font-size: 25px;
}

.sub-active {
	background-color: rgb(105, 203, 204) !important;
	color: white;
}

.subitem:hover {
	cursor: pointer;
}

.edit div {
	width: 80%;
}
</style>
